import {INITIAL_ADVANCED_TABLE_STATE} from '~/components'

const initialState = {
	advancedTable: {},
	applicationHeaders: [],
	filters: {},
	searchQueries: {},
}

////////////////////////////////////////////////////////////
// Copy pasted from web
////////////////////////////////////////////////////////////

export default function reduce(state = initialState, action) {
	switch (action.type) {
		case 'LOGOUT':
			// Without resetting this (strange things can happen mainly during QA) when somebody logs out and then logs in with
			// another user (which does not have access to the same data) of the same organisation (because this cache is org scoped).
			return initialState

		case 'ADVANCED_TABLE': {
			const {tableName, value, name} = action
			const otherTables = state.advancedTable
			const oldState = state.advancedTable[tableName] || INITIAL_ADVANCED_TABLE_STATE

			// A 'resetTable' flag is used to prevent infinity renders. Resetting both means editing the tanStack cache and our own Redux cache (below).
			const newState = value.resetTable ? {resetTable: true} : {...oldState, ...value}

			return {
				...state,
				advancedTable: {
					...otherTables,
					[tableName]: newState,
				},
			}
		}

		case 'APPLICATION_HEADERS': {
			const {headerNames, ...rest} = action
			return {
				...state,
				applicationHeaders: {
					...headerNames,
				},
			}
		}

		case 'FILTERS': {
			const {name, filterName, filterValue, clearFilters} = action
			const filters = state.filters
			const filtersInInstance = filters?.[name]

			// The clearFilters action uses the same hook to be DRY, simply adds an extra clearFilters = true prop.
			const newFilters = clearFilters ? {} : {...filtersInInstance, [filterName]: filterValue}

			return {
				...state,
				filters: {
					...filters,
					[name]: newFilters,
				},
			}
		}

		case 'SEARCH_QUERIES': {
			const {searchType, searchQuery} = action
			return {
				...state,
				searchQueries: {
					...state.searchQueries,
					[searchType]: searchQuery,
				},
			}
		}

		default:
			return state
	}
}
